import { Box, Select, MenuItem, FormControl, Typography } from "@mui/material";
import { useState, useEffect } from "react";

import Notifications from "@/components/Notifications/Notifications";
import { formatTimestamp } from "@/utils/util";

function EventForm({ event, updateEvent, allEvents }) {
  const [events, setEvents] = useState(allEvents);
  const [notification, setNotification] = useState({});

  useEffect(() => {
    if (allEvents) {
      setEvents(allEvents);
    }
  }, [allEvents]);

  const handleEventSelection = (e) => {
    updateEvent(e.target.value);
  };

  return (
    <Box data-testid="events-dropdown">
      {/* SELECT EVENT */}
      <Typography>Event:</Typography>
      <FormControl sx={{ width: "300px", marginTop: "4px" }}>
        <Select
          value={event}
          onChange={handleEventSelection}
          sx={{ backgroundColor: "white" }}
        >
          {events.map((event, index) => (
            <MenuItem key={index} value={event} sx={{ whiteSpace: "normal" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "baseline",
                }}
              >
                <Box
                  sx={{
                    maxWidth: "300px",
                    wordBreak: "break-word",
                    lineHeight: "1.2",
                  }}
                >
                  {event.event_name}
                </Box>
                <Box sx={{ color: "text.secondary" }}>
                  {formatTimestamp(event.event_date, true)}
                </Box>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </Box>
  );
}

export default EventForm;
